import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { Controller } from 'react-hook-form';
import FormHelperText from '@mui/material/FormHelperText';
import { MiniDropDownStyle } from '../../ui/styled';
import Box from '@mui/material/Box';

const CMPInputDropdown = (props) => {
  const {
    name,
    control,
    label,
    options,
    defaultId,
    errors,
    helperText,
    disabled,
    register,
    valueAsKey,
    monthId,
    cssOrScssList,
  } = props;

  const generateSingleOptions = () => {
    return options?.map((item, index) => {
      return (
        <MenuItem
          key={index}
          value={monthId ? item.mthId : cssOrScssList ? item.cntId : item.id}
        >
          {item.value}
          {monthId && item.mthId}
          {valueAsKey && item.key}
          {cssOrScssList && item.contactName}
        </MenuItem>
      );
    });
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <MiniDropDownStyle>
        {/*<InputLabel>{label}</InputLabel>*/}
        <Controller
          register={register}
          render={({ field: { onChange, onBlur, value } }) => (
            <Select
              sx={{height: '24px', width: '180px;'}}
              defaultValue={defaultId}
              onChange={onChange}
              onBlur={onBlur}
              value={value}
              error={errors}
              disabled={disabled}
            >
              {generateSingleOptions()}
            </Select>
          )}
          control={control}
          name={name}
        />
        <FormHelperText style={{ color: '#ff4d4f' }}>{helperText}</FormHelperText>
      </MiniDropDownStyle>
      <InputLabel sx={{paddingLeft: '6px;'}}>{label}</InputLabel>
    </Box>  
  );
};

export default CMPInputDropdown;
